import { bindable } from 'aurelia';

interface DurationOption {
    value: number;
    label: string;
}

export class DurationInput {
    @bindable public minutes: number = 5;
    @bindable public placeHolder: number = 5;
    @bindable public max: number;
    @bindable public min: number;
    @bindable public idvalue: string;

    public hourOptions: DurationOption[] = Array.from({ length: 24 }, (_, i) => ({ value: i, label: i.toString().padStart(2, '0') }));
    public minuteOptions: DurationOption[] = Array.from({ length: 60 }, (_, i) => ({ value: i, label: i.toString().padStart(2, '0') }));

    public get hours(): number {
        return Math.floor((this.minutes ?? 0) / 60);
    }

    public set hours(value: number) {
        this.minutes = (Number(value) || 0) * 60 + this.minutesPart;
    }

    public get minutesPart(): number {
        return (this.minutes ?? 0) % 60;
    }

    public set minutesPart(value: number) {
        this.minutes = this.hours * 60 + (Number(value) || 0);
    }
}
